import React from 'react';
import PropTypes from 'prop-types';
import {LeftGlyph, RightGlyph} from '../glyphicons/Glyphicons';

const Carousel = ({children, htmlId}) => {
    return(
        <div
            id={htmlId}
            className="carousel slide"
            data-ride="carousel">
            {children}
            <a
                className="left carousel-control"
                href={`#${htmlId}`}
                role="button"
                data-slide="prev">
                <LeftGlyph />
            </a>
            <a
                className="right carousel-control"
                href={`#${htmlId}`}
                role="button"
                data-slide="next">
                <RightGlyph />
            </a>
        </div>
    );
};

Carousel.propTypes = {
    //Child components.
    children: PropTypes.node,
    //Carousel id.
    htmlId: PropTypes.string
};

export default Carousel;


// WEBPACK FOOTER //
// ./src/components/Carousel/Carousel.js